import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { Api } from '../api.service';
import {
	BillingBusinessTypeIds,
	BillingSubType,
} from '@models/billingBusiness';

@Injectable({
	providedIn: 'root',
})
/**
 * Wrapper for the C# BillingDefaultsController.
 */
export class BillingDefaultsApiService extends Api {
	constructor(private http: HttpClient) {
		super(http);
	}

	/**
	 * Gets the subTypes that are in the billingDefaults with the specified billingBusinessTypeId.
	 */
	public getSubTypes(
		billingBusinessTypeId: BillingBusinessTypeIds,
	): Observable<BillingSubType[]> {
		const url = `${environment.api.baseUrl}/closer/billing-defaults/${billingBusinessTypeId}/sub-types`;

		return this.http.get<BillingSubType[]>(url);
	}
}
